import React, { ReactNode } from "react";
import SideBar from "../components/SideBar";
import Alert from "../components/Alert";

interface SidebarLayoutProps {
    children: ReactNode;
    isError: boolean;
    error: string | null;
    setIsError: any;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children, isError, error, setIsError }) => {
    const handleDismiss = (alertId: string) => {
        const alertElement = document.getElementById(alertId);
        if (alertElement) {
            setIsError(false);
            alertElement.style.display = 'none';
        }
    };
    
    return (
        <div className="w-full h-full flex ">
        {isError &&
            <Alert
                id="alert-2"
                color="red"
                iconColor="text-red-800 dark:text-red-400"
                textColor="text-red-800 dark:text-red-400"
                bgColor="bg-red-50 dark:bg-gray-800"
                onDismiss={() => handleDismiss('alert-2')}
            >
                {error === null ? "Some error happen" : error}
            </Alert>}
            <aside className="w-auto border-gray-700 fixed top-0 bottom-0 z-50" aria-label="Sidebar">
                <SideBar />
            </aside>
            <div className="w-full h-[100vh] ms-[70px]">
                {children}
            </div>
        </div>
    );
}
export default SidebarLayout;